
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/poplar",
      function () {
        return require("private-next-pages/destinations/poplar.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/poplar"])
      });
    }
  